import { useEffect, useState } from 'react';
import axios from 'axios';
 
import endpoints from '../constants/configs/endpoints';
 
const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': window.EMAIL,
        'csrftoken': window.csrf_token
    }
});
 
const setActiveHousehold = async householdId => {
    return await api.post(endpoints.SET_ACTIVE_HOUSEHOLD, { householdId }, {
        transformRequest: [( data ) => {
            return data.householdId;
        }]
    });
};
 
export default (multiHouseholdEnabled) => {
    const [ multiHouseholdDetails, setMultiHouseholdDetails ] = useState([]);
 
    useEffect(() => {
        if (multiHouseholdEnabled !== undefined && multiHouseholdEnabled) {
            getMultihouseholdDetails();
        }
    }, [multiHouseholdEnabled]);
 
    const getMultihouseholdDetails = async () => {
        try {
            const res = await api.get(endpoints.MULTIHOUSEHOLD_DETAILS);
            const households = res.data.households && res.data.households.sort((x, y) => x.active === y.active ? 0 : (x.active ? -1 : 1));
            setMultiHouseholdDetails(households);
        } catch (err) {
            console.error('In useMultiHousehold: getMultihouseholdDetails(): error in getting API = ', err);
        }  
    };
 
    return {
        multiHouseholdDetails,
        setActiveHousehold
    };
};